import { createContext, useContext, useState, useLayoutEffect } from 'react';
import { initializeApp } from 'firebase/app';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { app } from '../firebaseInit';

export const FirebaseContext = createContext(null);

export const useFirebase = () => {
    const context = useContext(FirebaseContext);
    if (!context) {
        throw new Error('useFirebase must be used within a FirebaseProvider');
    }
    return context;
};

export const FirebaseProvider = ({ children }) => {
    const [, setAuth] = useState(false); // force state update on auth change
    const fbApp = initializeApp(app);
    const auth = getAuth(fbApp);
    const firestore = getFirestore(fbApp);

    // persistent login more consistently
    useLayoutEffect(() => {
        const listener = onAuthStateChanged(auth, async (user) => {
            setAuth(!!user);
        });

        return () => { listener(); }
    }, [auth]);

    return (
        <FirebaseContext.Provider value={{ fbApp, auth, firestore }}>
            {children}
        </FirebaseContext.Provider>
    );
};
